import React from 'react';
import { Modal, Button, Typography } from '@scale/scaleui';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
  actionButtonVariant?: 'primary' | 'secondary' | 'danger' | 'neutral';
  actionButtonText?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  actionButtonVariant = 'primary',
  actionButtonText = 'Confirm',
}) => {
  return (
    <Modal open={isOpen} onClose={onClose} theme="scale-theme" title="Confirm Action">
      <div className="h-full flex flex-col space-y-6">
        <div className="max-w-sm">
          <Typography.Subtitle3>{message}</Typography.Subtitle3>
        </div>
        <div className="flex justify-end">
          <Button onClick={onClose} variant="neutral">
            Cancel
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="ml-2"
            variant={actionButtonVariant}
          >
            {actionButtonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
